import React, { useState } from 'react';
import { AccordionItem, Box, Inscription } from '@common-fe/common-fe';
import styled from 'styled-components';

interface Props {
  question: string;
  answer: string | React.ReactNode;
  index: number;
  initialExpanded?: boolean;
}

const FAQStyledBox = styled(Box)<{ isExpanded: boolean }>`
  cursor: pointer;
`;

const RenewalFAQModalItem: React.FC<Props> = ({ question, answer, index, initialExpanded = false }) => {
  const [isExpanded, setExpanded] = useState(initialExpanded);

  return (
    <FAQStyledBox
      data-testid={`renewal-faq-modal-item-${index}`}
      onClick={() => setExpanded(!isExpanded)}
      pad={isExpanded ? { vertical: 's', horizontal: 'm' } : { vertical: 's', left: 'm' }}
      round={isExpanded ? 'xs' : 'none'}
      background={isExpanded ? 'border1' : 'transparent'}
      isExpanded={isExpanded}
    >
      <AccordionItem
        testId={`renewal-faq-modal-accordion-${index}`}
        iconSize="24px"
        isExpanded={isExpanded}
        text={
          <Box
            background={isExpanded ? 'border1' : 'transparent'}
            margin={{ left: 'xxs' }}
            direction="row"
            align="center"
          >
            <Inscription color="textTitle" weight="normal" lineHeight="20px">
              {question}
            </Inscription>
          </Box>
        }
        isLeftArrow
      >
        <Box background="border1" margin={{ top: 's' }}>
          <Inscription color="textBody" lineHeight="20px" size="14px" style={{ whiteSpace: 'pre-line' }}>
            {answer}
          </Inscription>
        </Box>
      </AccordionItem>
    </FAQStyledBox>
  );
};

export default RenewalFAQModalItem;
